// globalState.js
import { makeAutoObservable } from 'mobx';
import { usePopup } from './components/PopUp';

class GlobalState {
  orderInCartMap = JSON.parse(localStorage.getItem('orderInCartMap')) || {};

  constructor() {
    makeAutoObservable(this);

    // Listen for changes in localStorage from other tabs
    window.addEventListener('storage', this.syncStateWithLocalStorage);
  }

  syncStateWithLocalStorage = (event) => {
    if (event.key === 'orderInCartMap') {
      this.orderInCartMap = JSON.parse(event.newValue) || {};
    }
  };

 updateOrder(serviceId, change) {
    const currentCount = this.orderInCartMap[serviceId] || 0;
    const newCount = Math.max(0, !change ? currentCount : currentCount + change);
  
    if (newCount === 0) {
      delete this.orderInCartMap[serviceId];
    } else {
      this.orderInCartMap[serviceId] = newCount;
    }
  
    this.saveStateToLocalStorage();
  }
  

  saveStateToLocalStorage() {
    localStorage.setItem('orderInCartMap', JSON.stringify(this.orderInCartMap));
  }
}

const globalState = new GlobalState();
export default globalState;
